import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiGit,
  DiAngularSimple,
  DiPostgresql,
  DiDocker,
  DiPython,
  DiMongodb 
} from "react-icons/di";
import { BiLogoTypescript,BiLogoKubernetes  } from "react-icons/bi";
import {
  SiNextdotjs,
  SiTailwindcss,
  SiCsharp,
} from "react-icons/si";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title="C#">
        <SiCsharp />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Javascript">
        <DiJavascript1 />
      </Col>
        <Col xs={4} md={2} className="tech-icons" title="Typescript">
        <BiLogoTypescript />
      </Col>
         <Col xs={4} md={2} className="tech-icons" title="Python">
        <DiPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Tailwindcss">
        <SiTailwindcss />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="NodeJS">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="React">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="NextJS">
        <SiNextdotjs />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Angular">
        <DiAngularSimple />
      </Col>
           <Col xs={4} md={2} className="tech-icons" title="Git">
        <DiGit />
      </Col>
       <Col xs={4} md={2} className="tech-icons" title="Docker">
        <DiDocker />
      </Col>
         <Col xs={4} md={2} className="tech-icons" title="Kubernetes">
        <BiLogoKubernetes  />
      </Col>
         <Col xs={4} md={2} className="tech-icons" title="PostgreSQL">
        <DiPostgresql />
      </Col>
         <Col xs={4} md={2} className="tech-icons" title="MongoDB">
        <DiMongodb  />
      </Col>
    </Row>
  );
}

export default Techstack;
